module.exports = __webpack_public_path__ + "static/61-hours-2008830f157e4f94db76d66b431f5b4f.jpg";